exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.section-card h4[data-v-383fe001]{font-size:1.1rem;margin:0\n}\n.section-card p[data-v-383fe001]{margin:10px 0 20px;font-size:.9rem;color:#6a6c6f;white-space:pre-wrap;text-align:justify\n}\n.section-card button[data-v-383fe001]{padding:10px 20px;color:#fff;font-size:1rem\n}\n", ""]);

// exports
